import script from "./messageCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./messageCard.vue?vue&type=script&setup=true&lang=ts"

import "./messageCard.vue?vue&type=style&index=0&id=59867ec0&lang=css"

const __exports__ = script;

export default __exports__